export default class Locations {
	constructor( module ) {
		this.bullets = module.querySelectorAll( '.bullet' );
		this.locations = module.querySelectorAll( '.location' );
		this.map = document.querySelector( '.module-career #map' );

		this.bullets.forEach( ( currentValue, currentIndex ) => {
			currentValue.addEventListener( 'click', () =>
				this.updateLocations( currentIndex )
			);
			const polyline = document.getElementById(
				currentValue.dataset.color + '-marker'
			);
			let points = polyline.getAttribute( 'points' );
			points += currentValue.dataset.coordinates + ' ';
			polyline.setAttribute( 'points', points );
		} );

		this.nextButtons = module.querySelectorAll( '.next-location' );
		this.nextButtons.forEach( ( currentValue ) => {
			currentValue.addEventListener( 'click', () =>
				this.updateLocations( this.currentIndex + 1 )
			);
		} );

		this.prevButtons = module.querySelectorAll( '.prev-location' );
		this.prevButtons.forEach( ( currentValue ) => {
			currentValue.addEventListener( 'click', () =>
				this.updateLocations( this.currentIndex - 1 )
			);
		} );

		this.currentIndex = 0;
		this.updateLocations( this.currentIndex );
		window.addEventListener( 'resize', () =>
			this.updateLocations( this.currentIndex )
		);
	}

	updateLocations( index ) {
		this.currentIndex =
			index < 0
				? this.locations.length - 1
				: index % this.locations.length;

		this.bullets.forEach( ( currentValue, currentIndex ) => {
			if ( currentIndex === this.currentIndex ) {
				currentValue.classList.add( 'active' );
				const polyline = document.getElementById( 'active-marker' );
				const points = currentValue.dataset.coordinates;
				const color = currentValue.dataset.color;
				polyline.setAttribute( 'points', points );
				polyline.setAttribute(
					'marker-end',
					`url(#${ color }-active)`
				);

				this.colorCode = color === 'purple' ? '#4b1ea0' : '#d70005';

				this.bullets.forEach( ( bullet ) => {
					bullet.style.borderColor = this.colorCode;
				} );

				if ( window.innerWidth < 1024 ) {
					const coordinates = points.split( ',' );
					const moveMap =
						-parseInt( coordinates[ 0 ] ) * 0.5 +
						200 -
						800 / window.innerWidth -
						0.2 * window.innerHeight;
					this.map.style.transform = this.map.style.webkitTansform =
						'translate3d(' + moveMap + 'px,0,0)';
				} else {
					this.map.style.transform = 'none';
				}
			} else {
				currentValue.classList.remove( 'active' );
			}
		} );

		this.nextButtons.forEach( ( button ) => {
			button.querySelector( 'svg' ).style.fill = this.colorCode;
		} );
		this.prevButtons.forEach( ( button ) => {
			button.querySelector( 'svg' ).style.fill = this.colorCode;
		} );

		this.locations.forEach( ( currentValue, currentIndex ) => {
			if ( currentIndex === this.currentIndex ) {
				currentValue.classList.add( 'active' );
			} else {
				currentValue.classList.remove( 'active' );
			}
		} );
	}
}
